import SchemaService from "@/services/SchemaService";

export const schema = {
  namespaced: true,
  state: {
    schema: {},
  },
  actions: {
    getSchema({ commit }, payload) {
      return SchemaService.GetSchema(payload).then(
        (schema) => {
          return Promise.resolve(schema);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default schema;
